import { storeCreator } from '@/utils/store/store.utils';

export enum InvestmentsTab {
  Dashboard = 'Dashboard',
  Performance = 'Performance ',
  Activity = 'Activity',
}

interface State {
  currentTab: InvestmentsTab;
  setCurrentTab: (tab: InvestmentsTab) => void;

  highlightedFund?: string;
  setHighlightedFund: (value?: string) => void;

  highlightedActivity?: string;
  setHighlightedActivity: (value?: string) => void;
}

const useInvestmentTabStore = storeCreator<State>((set) => ({
  currentTab: InvestmentsTab.Dashboard,
  setCurrentTab: (value: InvestmentsTab) =>
    set(() => ({
      currentTab: value,
    })),

  highlightedFund: '',
  setHighlightedFund: (value?: string) =>
    set(() => ({
      highlightedFund: value,
    })),

  highlightedActivity: '',
  setHighlightedActivity: (value?: string) =>
    set(() => ({
      highlightedActivity: value,
    })),
}));

export default useInvestmentTabStore;
